import axios from 'axios';

const accessManagementApi = axios.create({
    baseURL: process.env.REACT_APP_ACCESSMANAGEMENT_API_URL
});

export default accessManagementApi;